var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGamepadSvgrepoCom(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 293.953 293.953",
    style: {
      enableBackground: "new 0 0 293.953 293.953"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M219.602,99.555h-65.125v-19.43c0-18.985-15.445-34.431-34.43-34.431H85.424c-4.143,0-7.5,3.358-7.5,7.5s3.357,7.5,7.5,7.5 h34.623c10.714,0,19.43,8.717,19.43,19.431v19.43H74.352C33.354,99.555,0,132.909,0,173.906c0,40.998,33.354,74.353,74.352,74.353 c29.215,0,55.804-17.355,67.75-43.692h9.751c11.945,26.338,38.533,43.692,67.749,43.692c40.998,0,74.352-33.355,74.352-74.353 C293.953,132.909,260.6,99.555,219.602,99.555z M219.602,233.259c-24.741,0-47.122-15.589-55.691-38.791 c-1.088-2.946-3.896-4.902-7.035-4.902H137.08c-3.14,0-5.947,1.956-7.035,4.901c-8.571,23.202-30.952,38.791-55.693,38.791 C41.625,233.259,15,206.633,15,173.906c0-32.727,26.625-59.352,59.352-59.352h145.25c32.727,0,59.352,26.625,59.352,59.352 C278.953,206.633,252.328,233.259,219.602,233.259z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.957,166.406H81.852V146.07c0-4.142-3.357-7.5-7.5-7.5s-7.5,3.358-7.5,7.5v20.336H46.746c-4.143,0-7.5,3.358-7.5,7.5 c0,4.142,3.357,7.5,7.5,7.5h20.105v20.337c0,4.142,3.357,7.5,7.5,7.5s7.5-3.358,7.5-7.5v-20.337h20.105c4.143,0,7.5-3.358,7.5-7.5 C109.457,169.764,106.1,166.406,101.957,166.406z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 219.602,
    cy: 148.203,
    r: 10.668
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 219.602,
    cy: 199.608,
    r: 10.668
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 245.305,
    cy: 173.907,
    r: 10.668
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 193.898,
    cy: 173.907,
    r: 10.668
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGamepadSvgrepoCom);
export default __webpack_public_path__ + "static/media/gamepad-svgrepo-com.89974defe8ae37caf78cfca385b9e5ae.svg";
export { ForwardRef as ReactComponent };